import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { UiIcon } from '@huntflow/ui';
import { computed, inject, useCssModule } from 'vue';
import { removeLayerSymbol } from '@/shared/legacy/ui/base-layer/constants';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'PopupHeading'
},
  __name: 'heading',
  props: {
    border: { type: Boolean, default: true }
  },
  setup(__props: any) {





const css = useCssModule();

const removeLayer = inject(removeLayerSymbol);

const classes = computed(() => {
  return {
    [css.heading]: true,
    [css.border]: __props.border
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(classes.value),
    "data-qa": "popup-layout-heading"
  }, [
    _renderSlot(_ctx.$slots, "default"),
    (_unref(removeLayer))
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: _normalizeClass(_ctx.$style.closeButton),
          "data-qa": "close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(removeLayer) && _unref(removeLayer)(...args)))
        }, [
          _createVNode(_unref(UiIcon), { name: "close-28" })
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})